// @ts-nocheck

import { AxiosResponse } from 'axios'
import api from '../../config/api'

export type ValidateRecipientResponse = {
  id: string
  firstName: string
  lastName: string
  email: string
}

export type CreateTransferResponse = {
  id: string
  status: string
  createdAt: string
}

export type TransferDetailsResponse = {
  id: string
  status: string
  createdAt: string
  sender: {
    id: string
    firstName: string
    lastName: string
    email: string
  }
  event: {
    id?: string
    name?: string
    date: string
    location: string
    url: string | null
  }
  ticket: {
    id?: string
    name?: string
    customerTicketId?: string
  }
}

export const validateTransferRecipientService = async (payload: {
  email: string
  fullName: string
  document: string
}): Promise<ValidateRecipientResponse> => {
  const { data }: AxiosResponse<ValidateRecipientResponse> = await api.post(
    'api/ticket-transfers/validate-recipient',
    payload
  )
  return data
}

export const createTicketTransferService = async (payload: {
  customerTicketId: string
  email: string
  fullName: string
  document: string
  password: string
}): Promise<CreateTransferResponse> => {
  const { data }: AxiosResponse<CreateTransferResponse> = await api.post(
    'api/ticket-transfers',
    payload
  )
  return data
}

export const getTicketTransferByTokenService = async (
  token: string
): Promise<TransferDetailsResponse> => {
  const { data }: AxiosResponse<TransferDetailsResponse> = await api.get(
    `api/ticket-transfers/token/${token}`
  )
  return data
}

export const acceptTicketTransferService = async (
  id: string,
  password: string
): Promise<{ id: string; status: string; newCustomerTicketId: string }> => {
  const { data } = await api.post(`api/ticket-transfers/${id}/accept`, {
    password
  })
  return data
}

export const rejectTicketTransferService = async (
  id: string
): Promise<{ id: string; status: string }> => {
  const { data } = await api.post(`api/ticket-transfers/${id}/reject`)
  return data
}

export const cancelTicketTransferService = async (
  customerTicketId: string
): Promise<{ id: string; status: string }> => {
  const { data } = await api.post('api/ticket-transfers/cancel', {
    customerTicketId
  })
  return data
}

const getTransferErrorPayload = (error: any) => {
  const data = error?.response?.data
  if (!data) return null
  if (data?.code || data?.message?.code) {
    return {
      code: data.code || data.message?.code,
      message:
        data.message?.message ||
        (typeof data.message === 'string' ? data.message : null),
      remainingAttempts:
        data.remainingAttempts ?? data.message?.remainingAttempts
    }
  }
  return {
    code: typeof data.message === 'string' ? data.message : null,
    message: typeof data.message === 'string' ? data.message : null
  }
}

export const isTransferPasswordLockout = (error: any): boolean => {
  return getTransferErrorPayload(error)?.code === 'TRANSFER_PASSWORD_LOCKOUT'
}

export const isTransferInvalidPassword = (error: any): boolean => {
  const payload = getTransferErrorPayload(error)
  return (
    payload?.code === 'TRANSFER_INVALID_PASSWORD' ||
    payload?.message === 'invalid password'
  )
}

export const getTransferPasswordErrorMessage = (error: any): string => {
  if (isTransferPasswordLockout(error)) {
    return 'Você excedeu o número de tentativas. Transferências bloqueadas temporariamente.'
  }

  if (isTransferInvalidPassword(error)) {
    const remaining = getTransferErrorPayload(error)?.remainingAttempts
    if (typeof remaining === 'number' && remaining > 0) {
      return `Senha incorreta. Você ainda tem ${remaining} tentativa${
        remaining === 1 ? '' : 's'
      }.`
    }
    return 'Senha incorreta. Verifique e tente novamente.'
  }

  const rawMessage =
    error?.response?.data?.message?.message || error?.response?.data?.message

  if (typeof rawMessage === 'string' && rawMessage.trim()) {
    return rawMessage
  }

  return 'Não foi possível confirmar a transferência. Verifique sua senha.'
}
